(() => {
  const TARGET = 60; // 🎯 Unlock target

  // ===== Inject Progress Bar =====
  function injectProgressBar() {
    if (document.querySelector(".cart-progress")) return;

    const progressBar = `
      <div class="cart-progress" aria-hidden="false">
        <p class="progress-text" style="font-size:14px;margin-top:10px;text-align:center;color:#232323;font-weight:400;">&nbsp;</p>
        <div class="progress-bar" style="background:#eee; height:10px; border-radius:6px; overflow:hidden; margin-top:10px;">
          <div class="progress-fill" style="width:0%; height:100%; transition:width 0.4s ease;">&nbsp;</div>
        </div>
      </div>
    `;

    const drawerHeader = document.querySelector('.drawer__header');
    if (drawerHeader) {
      drawerHeader.insertAdjacentHTML("afterend", progressBar);
    } else {
      const cartDrawer = document.querySelector('.cart-drawer__inner') || document.querySelector('#CartDrawer');
      if (cartDrawer) {
        cartDrawer.insertAdjacentHTML('afterbegin', progressBar);
      }
    }
  }

 // ===== Update Progress Bar =====
function updateProgressBar(cartTotal) {
  injectProgressBar();

  const barWrapper = document.querySelector('.cart-progress');
  if (!barWrapper) return;

  if (!cartTotal || cartTotal <= 0) {
    barWrapper.style.display = "none";
    toggleSuggestedWrapper(0);
    return;
  } else {
    barWrapper.style.display = "block";
  }

  const fill = barWrapper.querySelector('.progress-fill');
  const text = barWrapper.querySelector('.progress-text');

  let percent = (cartTotal / TARGET) * 100;
  if (percent > 100) percent = 100;

  let message = "";
  if (cartTotal >= TARGET) {
    message = "🥳 Free gift unlocked 🎁 Add to cart below 🛒";
  } else {
    let remaining = (TARGET - cartTotal).toFixed(2);
    message = `Add <span class="inner-text-gfit" style="color:#18563B;font-weight:700;font-size:19px !important;">$${remaining}</span> more to unlock your FREE gift 🎁`;
  }

  fill.style.width = percent + "%";
  text.innerHTML = message;

  // ✅ ensure toggle check everytime
  setTimeout(() => toggleSuggestedWrapper(cartTotal), 100);
}

  // ===== Lock/Unlock Suggested Wrapper + Auto Remove =====
function toggleSuggestedWrapper(cartTotal) {
  const wrapper = document.querySelector(".drawer__suggested-product");
  if (!wrapper) return;

  const suggestedVariantId = wrapper.querySelector("[data-variant-id]")?.getAttribute("data-variant-id");
  if (!suggestedVariantId) return;

  if (cartTotal >= TARGET) {
    wrapper.classList.remove("locked");
    wrapper.style.pointerEvents = "auto";
    wrapper.style.opacity = "1";
  } else {
    wrapper.classList.add("locked");
    wrapper.style.pointerEvents = "none";
    wrapper.style.opacity = "0.5";

    // ✅ Auto remove if suggest product is already in cart
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const item = cart.items.find(i => i.variant_id == suggestedVariantId);
        if (item) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          })
          .then(() => {
            // re-trigger bar update after removal
            setTimeout(fetchCartAndUpdateBar, 200);
            document.dispatchEvent(new Event("cart:updated"));
          });
        }
      });
  }
}

  // ===== Fetch Cart Total =====
  function fetchCartAndUpdateBar() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const total = (cart.total_price || 0) / 100;
        updateProgressBar(total);
      })
      .catch(err => console.error("fetchCartAndUpdateBar error:", err));
  }

  // ===== Observe Drawer =====
  function observeDrawer() {
    const cartDrawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer__inner');
    if (!cartDrawer) return;
    const mo = new MutationObserver(() => {
      fetchCartAndUpdateBar();
    });
    mo.observe(cartDrawer, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', () => {
    setTimeout(fetchCartAndUpdateBar, 100);
  });

  document.addEventListener('DOMContentLoaded', () => {
    injectProgressBar();
    fetchCartAndUpdateBar();
    observeDrawer();
  });
})();



document.addEventListener("submit", function(e) {
  if (e.target.matches(".suggested-product-form")) {
    e.preventDefault();
    const variantId = e.target.dataset.variantId;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(() => {
      // fetch cart sections again (same as Shopify does after remove)
      fetch("/?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(sections => {
          const cartDrawer = document.querySelector("cart-drawer");
          cartDrawer.renderContents({
            id: variantId,
            sections: sections
          });
        });
    });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  // Intercept submit on suggested product
  document.body.addEventListener('submit', function (e) {
    const form = e.target.closest('.suggested-product-form');
    if (!form) return;

    e.preventDefault();

    const btn = form.querySelector('[data-suggested-add]');
    const variantId = form.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      // hide the suggestion block immediately
      const wrap = document.querySelector('[data-suggested-wrapper]');
      if (wrap) wrap.remove();

      // refresh cart drawer contents
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.renderContents === 'function') {
        // Dawn-style method
        return fetch('/cart.js').then(res => res.json()).then(cart => drawerEl.renderContents(cart));
      } else {
        // Fallback: Section Rendering API
        return fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}?sections=cart-drawer,cart-icon-bubble`)
          .then(res => res.json())
          .then(sections => {
            if (sections['cart-drawer']) {
              const tmp = document.createElement('div');
              tmp.innerHTML = sections['cart-drawer'];
              const newDrawer = tmp.querySelector('#CartDrawer');
              const curDrawer = document.querySelector('#CartDrawer');
              if (newDrawer && curDrawer) curDrawer.replaceWith(newDrawer);
            }
          })
          .catch(() => {});
      }
    })
    .catch(() => { btn.disabled = false; });
  });
});